export enum RacialColorEnum {
	WHITE = 1,
	BLACK = 2,
	YELLOW = 3,
	BROWN = 4,
	INDIGENOUS = 5,
}
